import { useQuery } from '@tanstack/react-query'

import { ProductListViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'

import { PDPReactQueryKeys } from '../types'

export const useGetCartAlsoBought = (enabled: boolean) => {
    return useQuery<ProductListViewModel[]>({
        queryKey: [PDPReactQueryKeys.AlsoBoughtCart],
        queryFn: async () =>
            fetchRequest({
                serviceName: 'ntl',
                method: 'GET',
                endpoint: '/carts/_my/also-bought',
            }),
        enabled,
    })
}
